module.exports = __webpack_public_path__ + "5996bcf3163ae814d80b5affa7377c96.jpg";